<script lang="ts">
  import { CheckIcon, LinkIcon } from "lucide-svelte";

  import { useCopy } from "$lib/ui/system/CopyButton.svelte";

  export let level: 1 | 2 | 3 | 4 | 5 | 6;
  export let id: string | undefined = undefined;

  let element: HTMLHeadingElement;
  let copied = false;

  const { handleCopy } = useCopy({
    analyticsEventName: "docs heading copied",
  });

  async function copyAndNavigate() {
    if (!id) return;
    const url = new URL(window.location.href);
    url.hash = id;
    await handleCopy(url.toString());

    copied = true;
    setTimeout(() => {
      copied = false;
    }, 500);
  }
</script>

<svelte:element this={`h${level}`} bind:this={element} {id} class="group">
  <!-- &nbsp; and keeping HTML elements adjacent (no whitespace) prevent copy-icon from wrapping to new line by itself-->
  <span><slot /></span>{#if id}&nbsp;<a
      href="#{id}"
      role="button"
      class="copy-link-parent relative opacity-0 group-hover:opacity-100 pr-4 transition-opacity duration-300"
      aria-label="Copy link to section"
      on:click={copyAndNavigate}
      on:keydown={(e) => e.key === "Enter" && copyAndNavigate()}
    >
      {#if copied}
        <CheckIcon size={14} />
      {:else}
        <LinkIcon size={14} />
      {/if}
    </a>
  {/if}
</svelte:element>

<style>
  /* Absolute positioning is also required to prevent copy-icon from wrapping to new line by itself */
  .copy-link-parent > :global(svg) {
    position: absolute;
    margin-left: 0.25rem;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
